export default function diagnosticQuestions() {
  return ([
    {
      type: "SF", //  listening to music on the ride home
      key: "-KPt6cf6BkRomFz6Ggaz"
    },
    {
      type: "SF", //  the man eating the pizza
      key: "-KOqLeXEvMjNuE6MGOop"
    },
    {
      type: "SF", //  after the football game ended
      key: "-KOqMWRFOrYgv-KjRYdy"
    },
    {
      type: "SF", // While we were swimming at the lake
      key: "-KPJiGC6bbtp7GkKMg3v"
    }
  ])
}
